import {
  REQUEST_INFO_FIELDS,
  RequestInfoField,
  RequestInfoStatus,
} from "@/lib/interfaces and Enums/ENUMRequestInformationStatus";
import { IExecutionRequestInfoState } from "@/store/requestInformationStore";

// LQC-637 — helpers for the OP-side conditional Request Information strip.
// The negotiation store keys on executionRequestId, but the condensed grid keys
// CP rows on cp.code — this bridges the two by reading the trade's own execution
// requests (the single source of truth for the slide-in, per LQC-1707).

// Resolve a CP's executionRequestId from the trade's execution requests. Returns
// undefined when the trade has no requests or no CP matches.
export function getExecutionRequestIdForCP(
  trade: any,
  cpCode: string,
): number | string | undefined {
  const requests = trade?.executionRequestCounterParties;
  if (!Array.isArray(requests)) return undefined;
  return requests.find((cp: any) => cp?.provider === cpCode)
    ?.executionRequestId;
}

// Display labels for the chips — concise to fit the cramped slide-in.
export const REQUEST_INFO_FIELD_LABELS: Record<RequestInfoField, string> = {
  direction: "Direction",
  competition: "Comp",
  cover: "Cover",
  coverSpread: "Cover Spread",
};

// The fields the OP still needs to action — i.e. those sitting at Requested.
// Released / Rejected / Withheld are not pending, so they don't keep the strip
// open. Order follows REQUEST_INFO_FIELDS for a stable chip order.
export function getRequestedFields(
  statuses: IExecutionRequestInfoState | undefined,
): RequestInfoField[] {
  if (!statuses) return [];
  return REQUEST_INFO_FIELDS.filter(
    (field) => statuses[field] === RequestInfoStatus.Requested,
  );
}
